import { loadStripe } from '@stripe/stripe-js';

import { ENVIRONMENT } from '../../config/environment';

export async function getStripeJS() {
  const stripeJs = await loadStripe(ENVIRONMENT.REACT_APP_STRIPE_PUBLIC_KEY);

  return stripeJs;
}
